<template>
  <SubscriptionsBody/>
</template>

<script>
// @ is an alias to /src
import SubscriptionsBody from '@/components/SubscriptionsBody.vue'

export default {
  name: 'SubscriptionsView',
  components: {
    SubscriptionsBody
  }
}
</script>
